// src/components/dashboard/logic/useSiteManager.js
import { useState } from "react";
import authAxios from "../../../api/authAxios";

export default function useSiteManager(authHeaders, activeOrgId, currentUser) {
  const [sites, setSites] = useState([]);
  const [siteModalOpen, setSiteModalOpen] = useState(false);
  const [siteModalMode, setSiteModalMode] = useState("add");
  const [editingSite, setEditingSite] = useState(null);

  // 🔑 derive role SAFELY
  const globalRole = currentUser?.global_role;

  /* -----------------------------
   * Modals
   * ----------------------------- */
  const openAddSite = () => {
    setSiteModalMode("add");
    setEditingSite(null);
    setSiteModalOpen(true);
  };

  const openEditSite = (site) => {
    setSiteModalMode("edit");
    setEditingSite(site);
    setSiteModalOpen(true);
  };

  /* -----------------------------
   * Submit
   * ----------------------------- */
  const submitSite = async (payload) => {
    try {
      if (payload.id) {
        await authAxios.patch(
          `/sites/${payload.id}/`,
          payload,
          { headers: authHeaders }
        );
      } else {
        await authAxios.post(
          `/organizations/${activeOrgId}/sites/`,
          {
            name: payload.name,
            address: payload.address,
            timezone: payload.timezone,
          },
          { headers: authHeaders }
        );
      }

      setSiteModalOpen(false);
      setEditingSite(null);
      fetchSites();
    } catch (err) {
      console.error("Site save failed:", err?.response?.data || err.message);
      throw err;
    }
  };

  /* -----------------------------
   * Fetch sites (THIS IS THE FIX)
   * ----------------------------- */
// useSiteManager.js
const fetchSites = async () => {
  try {
    const res = await authAxios.get("/sites/", { headers: authHeaders });
    setSites(res.data || []);
  } catch (err) {
    console.error("Failed to load sites:", err);
    setSites([]);
  }
};


  return {
    sites,
    fetchSites,
    submitSite,
    openAddSite,
    openEditSite,
    siteModalOpen,
    setSiteModalOpen,
    siteModalMode,
    editingSite,
    setEditingSite,
  };
}

